module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/rectification-042b3c0d8cef1904be45f502eb7a1035.svg";